export const getDepartmentsData = (detail:any) => {
  if (detail.departments) {
    if (detail.other_departments) {
      return `${detail.departments.join('、')}、${
        detail.other_departments
      }`
    }
    return detail.departments.join('、')
  }
  return ''
}
